export const VIEWS = {
  default: 'default',
  bookingDetails: 'bookingDetails',
  crewRegistration: 'crewRegistration'
};
